export class Constants {
    static readonly AppName = 'SMRTscape';
    static readonly AppVersion = '31102023';

    static readonly SmrtScapeTagLine01 = 'Access Your Irrigation and Lighting Controls';
    static readonly SmrtScapeTagLine02 = 'From Anywhere, Anytime';

    static readonly OneMinuteInSeconds = 60;
    static readonly TwoMinutesInSeconds = 120;
    static readonly DefaultProcessingOverlayTimeoutInSeconds = Constants.OneMinuteInSeconds;
    static readonly DefaultHttpCallTimeoutInSeconds = Constants.OneMinuteInSeconds;
    static readonly OneMinuteInMs = Constants.OneMinuteInSeconds * 1000;
    static readonly TwoMinutesInMs = Constants.TwoMinutesInSeconds * 1000;
    static readonly MinWaitTimeForDevicebusyInSeconds = 30;
    static readonly YearsRange = (new Date().getFullYear() - 1) + ':' + (new Date().getFullYear() + 10);
    static readonly MaxSceneAllowed = 4;
    static readonly MaxThemeAllowed = 15;
    static readonly MagnetoFwUgExpireTimeInSeconds = 8 * 60 * 1000;
    static readonly GatewayFwUgExpireTimeInSeconds = 5 * 60 * 1000;
    static readonly DefaultFwUgExpireTimeInSeconds = 5 * 60 * 1000;
    static readonly HalfMinuteInMilliSeconds = 30000;                   //30 seconds
    static readonly MinuteInMilliSeconds = 60000;                   //60 seconds
    static readonly RGBColorType = 0;
    static readonly CCTColorType = 1;
    static readonly DefaultRGBColorType = 2;
    static readonly DefaultCCTColorType = 3;

    static readonly DefaultSceneOrdinalPosition = 1;
    static readonly DefaultThemeOrdinalPosition = 1;

    static readonly DefaultIdleStateText = 'All Idle';
    static readonly StaticManualProgramDurationInSec = 60 * 2;

    static readonly ProgramDefaultIdleState = 'Idle';

    static readonly WeatherApiKey = 'U2Z5BpeHxQ9i3F9nz7Mm1yVMxZaysgG8fw6Jb6Ec';

    static readonly DateUTCFormat = 'MM/dd/yyyy hh:mm:ss a';
    static readonly TimeZone = 'UTC';
    static readonly imageBasePath = '../../../assets/images/';

    static readonly imageWhatsNew = {
        IMG_DONT_SHOW: Constants.imageBasePath + 'whats-new/dont-show.png',
        IMG_DONT_SHOW_HOVER: Constants.imageBasePath + 'whats-new/dont-show-over.png',
        IMG_DONT_SHOW_CHECKED: Constants.imageBasePath + 'whats-new/dont-show-check.png',
        IMG_DONT_SHOW_HOVER_CHECKED: Constants.imageBasePath + 'whats-new/dont-show-over-check.png',
        IMG_MORE_INFO: Constants.imageBasePath + 'whats-new/more-info.png',
        IMG_MORE_INFO_HOVER: Constants.imageBasePath + 'whats-new/more-info-over.png'
    };

    static readonly WeatherStandardConditionNames = {
        'regular': ['sun', 'clear'],
        'cloud': ['partly sunny', 'partlysunny', 'partly cloudy', 'partlycloudy', 'cloudy'],
        'rain': ['rain', 'rainy', 'raining'],
        'snow': ['snow'],
        'thunder': ['lightning', 'thunderstorm'],
        'shower': ['shower', 'showers'],
        'drizzle': ['drizzle'],
        'freezing rain': ['freezing rain', 'freezingrain', 'hail'],
        'sleet': ['sleet']
    };

    static readonly WeatherConditionAndCloudCoverToIconMap = {
        'regular': ['sun', 'cloud-sun', 'cloud-sun', 'cloud', 'cloud'],
        'cloud': ['cloud-sun', 'cloud-sun', 'cloud-sun', 'cloud', 'cloud'],
        'rain': ['showers-sun', 'showers-sun', 'showers-sun', 'rain', 'rain'],
        'snow': ['snow-sun', 'snow-sun', 'snow-sun', 'snow', 'snow'],
        'thunder': ['thunder-sun', 'thunder-sun', 'thunder-sun', 'thunder', 'thunder'],
        'shower': ['showers-sun', 'showers-sun', 'showers-sun', 'showers', 'showers'],
        'drizzle': ['drizzle-sun', 'drizzle-sun', 'drizzle-sun', 'drizzle', 'drizzle'],
        'freezing rain': ['hail-sun', 'hail-sun', 'hail-sun', 'hail', 'hail'],
        'sleet': ['sleet-sun', 'sleet-sun', 'sleet-sun', 'sleet', 'sleet']
    };

    static readonly Strings = {
        // NOTE: ADD KEYS ALPHABETICALLY
        Adding: 'Adding',
        AddingGateway: 'Adding Gateway',
        AddingIrrigationController: 'Adding Irrigation Controller',
        AddingLpcu: 'Adding LPCU',
        UpdatingDevice: 'Updating Device',
        SyncDevice: 'Synchronizing Device',
        RefreshDeviceConfiguration: "Refreshing Device configuration...",
        ScanTimeoutErrorMessage: "Please make sure your Device is powered on and try again after some time.",
        UpdateDeviceSuccess: 'Device has been updated successfully.',
        AddingMagneto: 'Adding Inspira',
        AddMagnetoResponseWait: 'Waiting for Device to respond',
        AddMagnetoWithoutSceneInfoMessage: 'You cannot add Device as you do not have a Scene. Please first add Scene then retry to add the Device.',
        LoadingDevices: 'Loading Devices...',
        LoadingScenes: 'Loading Scenes...',
        LoadingSceneDetails: 'Loading scene details...',
        LoadingThemes: 'Loading Themes...',
        LoadingThemeDetails: 'Loading theme details...',
        LoadingFixtures: 'Loading fixtures...',
        AuxiliaryChangesCouldNotBeSynched: 'Auxiliary changes could not be synchronized with the Controller.',
        AuxiliaryChangesSavedSuccessfully: 'Auxiliary changes were saved successfully.',
        Canceling: 'Canceling',
        CancelingDiscoveryMode: 'Canceling discovery mode',
        DiscoveryUnsuccessful: 'Discovery unsuccessful',
        ChangesCouldNotBeSyncrhonizedWithController: 'The changes could not be synchronized with the Controller.',
        ClimateLogicIsRequestingConfigFromController: 'Climate Logic is requesting configuration from the Controller',
        CommCardSuccessfullySynchronized: 'The Communication Card was successfully synchronized.',
        ConfigFileIsNotCompatibleWithDevice: 'The selected configuration file is not compatible with this Controller.',
        ConfigSuccessfullySentToController: 'Configuration has been sent successfully to the Controller.',
        ControllerAddedButDidNotRespond: 'The Controller was added, but it did not respond in the allotted time.',
        ControllerAddedInNonProgrammableMode: 'Controller added in non-programmable mode.',
        ControllerSuccessfullyAdded: 'The Controller was added successfully.',
        ControllerSuccessfullyDeleted: 'The Controller was deleted successfully.',
        ControllerSuccessfullyUpdated: "Success! Your Device Configuration Has Been Saved.<br/>We're now synchronizing your device to ensure the changes take effect. This may take a few moments. Please do not turn off your device or close this page until synchronization is complete.<br/>Thank you for your patience.",
        ControllerSuccessfullySynchronized: "Your Device Has Successfully Synchronized.",
        CreatingLocation: 'Creating Location',
        CreatingScene: 'Creating Scene',
        CreatingTheme: 'Creating Theme',
        DeletingDevice: 'Deleting Device',
        DeleteDeviceMessage: 'Delete Device:',
        FindingDevice: 'Finding Device',
        DeletingIrrigationController: 'Deleting Irrigation Controller',
        DeletingLpcu: 'Deleting LPCU',
        DeletingScene: 'Deleting Scene',
        DeletingTheme: 'Deleting Theme',
        DeleteThemeSuccessMessage: 'Theme deleted successfully.',
        UpdateThemeSuccessMessage: 'Theme updated successfully.',
        GettingThemeDetails: 'Getting Theme details',
        DoNotWaterOnTheseDays: 'Do not water on these days',
        Devices: 'Devices',
        DoNotShowAgain: 'Do not show again',
        EnableNewFeaturesBannerText: 'Enable New Features Now!',
        FileIsWrongFormat: 'The selected file is not a valid Controller configuration file.',
        ForASpecifiedAmountOfTime: 'For a specified amount of time',
        ForASpecifiedAmountOfDay: 'For a specified amount of days',
        GatewayCouldNotSendUpdateInAllottedTime: 'The Gateway could not send the update in the allotted time.',
        GatewayDidNotAcknowledgeRequest: 'The Gateway did not acknowledge the request.',
        GatewayHasBeenAddedToLocation: 'The Gateway has been added to the Location.',
        GatewayHasBeenReplaced: 'The Gateway has been replaced successfully.',
        GatewayIsRequestingConfigFromClimateLogic: 'Gateway is requesting configuration from Climate Logic',
        GatewayIsRetrievingConfiguration: 'Gateway is retrieving configuration',
        GatewayIsSendingConfigToController: 'Gateway is sending configuration to Controller',
        GatewayIsTakingLongerThanExpected: 'The Gateway is taking longer than expected...',
        GatewaySettings: 'Gateway Settings',
        GatewayUnableToMakeRequestedUpdate: 'The Gateway was unable to make the requested update.',
        GatewayUnableToRetrieveConfig: 'The Gateway was unable to retrieve the Controller configuration. Please try again.',
        GatewayUpdateRequiredMessage: 'The Controller was added but the Firmware needs to be updated. The controller\'s ' +
            'functionality will be limited until the firmware is upgraded. This can take 10-90 minutes. ' +
            'The firmware update will start automatically.',
        ImageSelection: 'Image Selection',
        ImportingControllerConfiguration: 'Importing Controller configuration',
        InstallingFw: 'Installing Firmware',
        InstallingFwOnCommCard: 'Installing Firmware on Communication Card',
        InstallingFwOnController: 'Installing Firmware on Controller',
        InstallingFwOnDevice: 'Installing Firmware on Device',
        InstallingGatewayFw: 'Installing Gateway Firmware...',
        FinalizingGatewayFirmwareUpdate: 'Finalizing Gateway Firmware update...',
        FirmwareUpgrading: 'Firmware upgrade in process',
        FirmwareUpgradeRequired: 'Firmware upgrade required',
        FirmwareUpgradeCompleteMessage: 'Firmware upgrade is completed. The site needs to be refreshed to display the updated features.',
        FirmwareUpgradeConfirmMessage: 'Firmware upgrades can take up to an hour, during which time the site will not be usable.<br />Are you sure you want to upgrade now?',
        FirmwareUpgradingError: 'The Firmware upgrade encountered an error. Please try again.',
        IrrigationController: 'Irrigation Controller...',
        IrrigationSuccessfullyStopped: 'Irrigation stopped successfully.',
        LlpAppName: 'Light Logic Plus',
        Loading: 'Loading',
        LpcuUpdated: "LPCU has been updated successfully.",
        LpcuScan: "LPCU scanned successfully.",
        InspiraScanSuccessMessage: "Inspira scanned successfully.",
        InspiraScanFailureMessage: "Inspira scan failed due to error code -",
        NoResponseFromGateway: 'No response from gateway',
        OperationCompletedSuccessfully: 'The requested operation completed successfully.',
        PreparingFirmwareUpgrade: 'Preparing for Firmware upgrade.',
        PaaswordRequirementsMessage: 'Use 8 or more characters with a mix of letters, numbers & symbols',
        RainDialUpdateDelayMsg: 'Changes may take up to 2 minutes before they are visible on your Rain Dial Controller.',
        RefreshingControllerPreferences: 'Refreshing Controller preferences...',
        RefreshingGatewayNetworkConfiguration: 'Refreshing Gateway network configuration',
        ReplaceCommCard: 'Replace Communication Card',
        ReplacingCommCard: 'Replacing Communication Card.',
        ReplacingGateway: 'Replacing Gateway',
        RequestingControllerConfigFromGateway: 'Requesting Controller configuration from Gateway...',
        RunningModeChangePending: 'The requested running mode change is pending. The Controller will eventually self-heal, or you can try again to update.',
        ResynchingGateway: 'Resynching Gateway',
        RunningModeSuccessfullyUpdated: 'Running mode updated successfully.',
        SavingChanges: 'Saving changes...',
        SavingAuxiliaryChanges: 'Saving auxiliary changes...',
        SavingGateway: 'Saving Gateway',
        SavingImage: 'Saving Image',
        SavingRunningMode: 'Saving running mode...',
        SavingScene: 'Saving Scene',
        SavingTheme: 'Saving Theme',
        SavingScheduleChanges: 'Saving schedule changes...',

        SceneCreationFailed: 'Scene creation failed',
        SceneUpdateFailed: 'Scene update failed',

        ThemeCreationFailed: 'Theme creation failed',
        ThemeUpdateFailed: 'Theme update failed',

        SendingConfigToController: 'Sending configuration to Controller...',
        SendingDiscoveryModeRequestToGateway: 'Sending discovery mode request to Gateway',
        SendingRequestForControllerConfigurationToGateway: 'Sending request for Controller configuration to Gateway',
        SendingRequestToGateway: 'Sending request to Gateway',
        SendingRequestToSyncCommCard: 'Sending request to synchronize Communication Card...',
        ScheduleChangesCouldNotBeSynched: 'The schedule changes could not be synchronized with the Controller.',
        ScheduleChangesSavedSuccessfully: 'The schedule changes were saved successfully.',
        ServerCommunicationWasLost: 'Server communication was lost.',
        SmrtScapeAppName: 'SMRTscape',
        SMRTScapeUnableToUpdateGateway: 'SMRTScape was unable to update the Gateway Firmware. <br />Please make sure Gateway is powered on.',
        SMRTScapeUnableToUpdateMagneto: 'SMRTScape was unable to update Inspira Firmware. <br />Device not communicating with gateway. Please make sure your device and gateway are power on and within communication range, gateway connected to the internet.',
        SMRTScapeUnableToUpdateEvolution: 'SMRTScape was unable to update Evolution Firmware. <br />Device not communicating with gateway. Please make sure your device and gateway are power on and within communication range, gateway connected to the internet.',
        SMRTScapeUnableToUpdateSMRTR: 'SMRTScape was unable to update SMRT-R Firmware. <br />Device not communicating with gateway. Please make sure your device and gateway are power on and within communication range, gateway connected to the internet.',
        SMRTScapeUnableToUpdateDevice: 'SMRTScape was unable to update Device Firmware. <br />Device not communicating with gateway. Please make sure your device and gateway are power on and within communication range, gateway connected to the internet.',
        StoppingIrrigation: 'Stopping Irrigation...',
        SynchronizingChangesWithController: 'Synchronizing changes with Controller...',
        SynchronizingCommCard: 'Synchronizing Communication Card...',
        SynchronizingConfigWithController: 'Synchronizing configuration with Controller',
        SynchronizingSchedChangesWithController: 'Synchronizing schedule changes with the Controller...',
        //TheControllerWasSuccessfullyUpdated: 'The Controller was updated successfully.',
        TheSceneWasSuccessfullyCreated: 'The Scene has been created successfully.',
        TheSceneWasSuccessfullyUpdated: 'The Scene has been updated successfully.',

        TheThemeWasSuccessfullyCreated: 'The Theme has been created successfully.',
        TheThemeWasSuccessfullyUpdated: 'The Theme has been updated successfully.',

        TheScheduleWasSuccessfullyUpdated: 'The Schedule has been updated successfully.',
        TheWirelessDevicesHaveBeenSuccessfullyUpdated: 'The wireless Devices have been updated successfully.',
        UnableToAddController: 'Unable to add Controller',
        UnableToCommunicateWithGateway: 'Unable to communicate with the Gateway.',
        UnableToCreateScene: 'Unable to create Scene. Please check network and device connectivity and try again.',
        UnableToCreateTheme: 'Unable to create Theme. Please check network and device connectivity and try again.',
        UnableToProcessRequest: 'Unable to process request.',
        UnableToRetrieveConfig: 'Unable to retrieve Controller configuration.',
        UnableToSendConfigToController: 'Unable to send configuration to Controller.',
        SuccessfullySentServerConfigurationToController: 'Successfully sent configuration to controller.',
        UnableToSendRequestToGateway: 'Unable to send request to Gateway.',
        UnableToStopIrrigation: 'Unable to stop Irrigation.',
        UnableToSynchronizeCommCard: 'Unable to synchronize Communication Card.',
        UnableToUpdate: 'Unable to update.',
        UnableToUpdateRunningMode: 'Unable to update running mode.',
        UnableToUpdateCommunicationCard: 'SMRTScape was unable to update the Communication Card\'s firmware. The Controller was added, but it has been configured as a non-programmable controller.',
        UnableToUpdateController: 'Unable to Synchronize the Device. Please Try Again.',
        UnableToUpdateDevice: 'Unable to update the Device. Please try again.',
        UnableToUpdateDevices: 'Unable to update Devices. Please check network and device connectivity and try again.',
        UnableToUpdateScene: 'Unable to update Scene. Please check network and device connectivity and try again.',
        UnableToUpdateTheme: 'Unable to update Theme. Please check network and device connectivity and try again.',
        UnableToUpdateSchedule: 'Unable to update the Schedule. Please try again.',
        UnableToUpdateZone: 'Unable to update the Zone. Please try again.',
        UntilNextScheduledOff: 'Until next scheduled off',
        UpdatingControllerCommunicationSettings: 'Updating Controller communication settings.',
        UpdatingGatewayNetworkConfiguration: 'Updating Gateway Network configuration',
        UpdatingIrrigationController: 'Updating Irrigation Controller',
        UpdateInProgress: 'Update in progress',
        Updating: 'Updating',
        UpdatingApan: 'Updating APAN',
        UpdatingLocation: 'Updating Location',
        UpdatingScene: 'Updating Scene',
        UpdatingTheme: 'Updating Theme',
        UpdatingWirelessRelayLpcu: 'Updating Wireless Relay / LPCU',
        WaitingForGatewayToRetrieveConfig: 'Waiting for Gateway to retrieve Controller configuration...',
        WaitingForGatewayToUpdaterunningMode: 'Waiting for Gateway to update running mode...',
        WirelessDeviceHasBeenUpdated: 'Wireless Device has been updated successfully.',
        WirelessDevicesHaveBeenUpdated: 'Wireless Devices have been updated successfully.',
        WirelessDeviceUpdateFailed: 'Wireless Device update failed.',

        //Colors
        AddingColor: 'Adding Color',
        LoadingColors: 'Loading Colors',
        InspiraAddSuccessMessage: "Inspira has been added successfully.",
        InspiraUpdateSuccessMessage: "Inspira has been updated successfully.",
        InspiraSyncSuccessMessage: "Inspira synced successfully.",
        InspiraAddFailureMessage: "Inspira add failed due to error code -",
        InspiraAddWithOldFirmware: "Inspira added with limited features. To enable all features Firmware needs to be upgraded.",
        SceneTimeScheduleMessage: 'If schedule is enabled then Day and Time is mandatory.',
        FixturePreviewMessage: 'Are you sure to leave this page because fixture preview is still running?',
        FixturePreviewContinue: 'Fixture Preview continue?',
        LoadingFixture: 'Loading Fixture Details...',
        FixturePreviewCancelled: 'Fixture preview cancelled successfully.',
        FixturePreviewCompletedMessage: 'Fixture preview has been completed.',
        FwUgMessageSent: "Firmware upgrade message sent.",
        FwUgCancelled: 'Firmware upgrade has been cancelled.',
        ThemeDeleteConfirmationMessage: 'Do you want to delete theme - ',
        ThemeCreateSuccessMessage: 'Now you can change the Theme Name, Start Date, End Date, add the Scenes, change the color settings for Inspira devices',
        LoadingThemeUpdate: 'Updating Theme...',
        FwUgComplete: 'Firmware upgrade complete.',
        FwUgFailed: 'Firmware upgrade failed.',
        CancelDeviceFwUg: 'Do you want to cancel the <br />firmware upgrade for this device?',
        //FirmwareUpgradeResume: 'SMRTScape was unable to update Device Firmware. The firmware update will resume automatically within timespan of 8 hours and if Device is Powered on and within communication range. <br />Do you want to Cancel this Firmware Upgrade?',
        FirmwareUpgradeResume: 'SMRTScape was unable to update Device Firmware.<br />Please try again after sometime.',
        ManualThemePlayInfoMessage: 'Please make sure scene with names - sceneNames is running before applying the theme',
        ColorDeleted: 'Color deleted successfully.',
        RelayUpdated: 'Edit Wireless Relay/LPCU has been updated successfully.',
        ManualThemePlayInfoIfNoSceneMessage: 'Please make sure you have at least one scene and its mapped with your theme before applying theme',
        FixtureSaveFailMessage: 'Changes saved successfully but the device failed to update.<br/> The device will eventually self-heal next time communication is established, or you can try update again.',
        FixtureSaveLoadingSpinnerMessage: 'Saving Fixture settings...',
        PreferencesSuccessMessage: 'Preferences saved successfully',
        UnableToPerformRequestedOp: 'Unable to perform requested operation.',
        UnableToReplaceCommCard: 'Unable to replace Communication Card.',
        AuxiliaryUpdated: 'The auxiliary has been updated successfully.',
        RetrieveConfigSuccess: 'The controller configuration has been successfully retrieved.',
        MiniReceiverFound: 'Mini-receiver found.',
        DeleteIrrigationController: 'Are you sure you want to delete the irrigation controller ',
        ControllerConfigurationImported: 'Controller configuration has been imported.',
        SMRTScapeUnableToUpdateKD2: 'SMRTScape was unable to update KD2 Firmware. <br />Device not communicating with gateway. Please make sure your device and gateway is power on and within communication range, gateway connected to internet.',
        NoFirmwareVersion: "No firmware versions available for this device type.",
        LocationUpdatedSuccessfully: 'Location was successfully updated.',
        RunningModeFailed: 'Running Mode change failed. Please try again.',
        RunningModeReqFailed: 'The request to save running mode was not sent successfully. Please try again.',
        RunningModeSuccessfully: 'Running Mode successfully changed.',
        IrrigationStopReq: 'The request to stop irrigation was sent successfully.',
        IrrigationStationStopReq: 'The request to stop Station irrigation was sent successfully.',
        IrrigationProgramStopReq: 'The request to stop Program irrigation was sent successfully.',
        IrrigationStopReqFailed: 'The request to stop irrigation was not sent successfully. Please try again.',
        IrrigationStationStopReqFailed: 'The request to stop Station irrigation was not sent successfully. Please try again.',
        IrrigationProgramStopReqFailed: 'The request to stop Program irrigation was not sent successfully. Please try again.',
        IrrigationStopAllReq: 'The request to stop all irrigation for this location was sent successfully.',
        ControllersStopReqFailed: 'One or more controllers did not receive the request to stop irrigation. Please try again.',
        UnsavedChanges: 'You have unsaved changes. You will lose your changes if you continue.<br>Are you sure you want to continue?',
        RunTimeMsg: 'Please enter a run-time greater than 0 minutes.',
        CallerVerificationIncomplete: 'The caller hasn\'t completed the verification process.',
        NoDates: 'Start Date - Not Set<br/>End Date - Not Set',
        SceneFailedDevices: 'Scene updated successfully but the following devices failed to update:',
        DevicesSelfHeal: 'The devices will eventually self-heal, or you can try update again.',
        FinalizingSomeTime: 'Finalizing (this may take a few minutes)...',
        FinishingUp: 'Finishing up...',
        Installing: 'Installing',
        Finalizing: 'Finalizing',
        FirmwareUploaded: 'Firmware uploaded successfully.',
        FirmwareDeleted: 'Firmware deleted successfully.',
        ControllerAddFailed: 'Failed to add controller.',
        LXCBlocksRecievedSuccess: 'LXC Blocks were received successfully.<br/>Now controller config will get fetched in background.',
        LXCBlocksRecievedFailed: 'LXC Block fetching failed. Please try again after some time.',
        GatewayOffline: 'Please make sure Gateway is powered on and try again after some time.',
        InspiraIncompatibleVersion: 'firmware Version < 0.43',
        InspiraVesrionIncompatibleMessage: 'Inspira version is not compatible.',
        InvalidInspira: 'The entered Smart ID is invalid.',
        FixturePreviewInitiatedMessage: 'Fixture Preview Initiated...',
        AddRGBColorErrMsg: 'Can not add this color. Please select CCT color from CCT Palette.',
        UnableToAddMagneto: 'Unable to add Inspira. Add Inspira taking longer than usual.  Please try again in sometime.',
        FetchingGatewayNetworkConfiguration: 'Fetching Gateway network configuration',
        UnableToDeleteGateway: 'Unable to delete Gateway.',
        DuplicateDevice: 'The device you are trying to add in this account is already present.',
        UnableToGetControllerDetails: 'Unable to get Controller Details',
        ThemeApply: 'The request to apply theme was sent successfully.',
        ThemeApplyFail: 'The request to apply theme failed. Please try again.',
        ThemeDiscard: 'The request to discard theme was sent successfully.',
        ThemeDiscardFail: 'The request to discard theme failed. Please try again.',
        SceneLightStart: 'The request to start scene lights was sent successfully.',
        SceneLightStop: 'The request to stop scene lights was sent successfully.',
        ResumeAllTheme: 'The request to resume all theme schedule was sent successfully.',
        TestAllStations: 'The request to test all stations has been successfully sent.',
        TestAllStationsFail: 'The request to test all stations was not sent successfully. Please try again.',
        FwUgStart: 'Starting Firmware Upgrade',
        SyncDevConfig: 'Synchronizing device configuration...',
        SevDevConfig: 'Saving device configuration...',
        LoadLocDetails: 'Loading Location details...',
        LoadIrrDetails: 'Loading Irrigation Details...',
        IdleMsg: 'You Have Been Idle!'
    };

    static readonly Time = {
        OneMinute: 60 * 1000,
        TwoMinutes: 60 * 1000 * 2,
        FiveMinutes: 60 * 1000 * 5,
    };

    static readonly SystemIdleTimeoutInSec =   5 * 60 * 60 ;   //for 5 hour if user is idle
    static readonly TimeoutInSec = 10 * 60;      //then he will timeout in 10 min

    static readonly DaySelectionArrays = {
        All: [0, 1, 2, 3, 4, 5, 6],
        Weekdays: [1, 2, 3, 4, 5],
        Weekends: [0, 6],
        None: []
    };

    static readonly MessageCommandCode = {
        FmWare: 1000,
        Wakeup: 1003
    };

    static readonly GatewayReportCommandCode = {
        Logs: 1009,
        History: 1010
    };

    static readonly DaysOfTheWeek = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

    static readonly enableNewFeaturesBannerTimeout = 7 * 60 * 1000;

    static readonly gatewayStatusCheckInterval = 60 * 1000;

    static readonly longPollInterval = 30 * 1000;

    static readonly shortPollInterval = 10 * 1000;

    static readonly noInternetTimeFrameInMinutes = 1;

    static readonly climateLogicType = [
        { Text: 'Climate Logic Wireless Receiver', Value: '1' },
        { Text: 'Climate Logic Mini-Receiver', Value: '4' },
    ];

    static readonly activeControllerCheckInterInMs = 60 * 1000;

    static readonly defaultStationsHeaderText = 'Stations';
    static readonly defaultStationHeaderText = 'Station';
    static readonly defaultProgramsHeaderText = 'Programs';
    static readonly defaultProgramHeaderText = 'Program';
    static readonly defaultEvoOrEvoAgStationsHeaderText = 'Zones';
    static readonly defaultEvoOrEvoAgStationHeaderText = 'Zone';
    static readonly defaultEvoOrEvoAgProgramsHeaderText = 'Schedules';
    static readonly defaultEvoOrEvoAgProgramHeaderText = 'Schedule';

    static readonly twelveHourInSeconds = 12 * 60 * 60;
    static readonly rdMaxStationRunTimeInMinutes = (5 * 60) + 59;
    static readonly rdMaxStationRunTimeInSeconds = Constants.rdMaxStationRunTimeInMinutes * 60;

    static readonly zoneTileImageWidth = 262;
    static readonly zoneTileImageHeight = 210;

    static readonly defaultManualRuntimeInMin = 240;

    //For Themes, Fixtures
    static readonly warmMin = 0;
    static readonly coolMin = 0;
    static readonly warmMax = 255;
    static readonly coolMax = 255;
    static readonly beamAngleMin = 0;
    static readonly beamAngleMax = 20;
    static readonly beamAngleSliderIncrementStep = 2;
    static readonly beamAngleDefault = 10;

    static readonly dimmingMin = 5;
    static readonly dimmingMax = 100;
    static readonly dimmingSliderIncrementStep = 2;
    static readonly dimmingDefault = 50;

    static readonly brightnessMin = 0;
    static readonly brightnessMax = 100;
    static readonly brightnessSliderIncrementStep = 2;
    static readonly brightnessDefault = 50;

    static readonly warmDefault = 0;
    static readonly coolDefault = 0;

    static readonly kelvinMin = 2100;
    static readonly kelvinMax = 6500;
    static readonly kelvinSliderStep = 100;

    static readonly kelvinTable = [
        { kelvin: 1000, rgb: [255, 56, 0] },
        { kelvin: 1100, rgb: [255, 71, 0] },
        { kelvin: 1200, rgb: [255, 83, 0] },
        { kelvin: 1300, rgb: [255, 93, 0] },
        { kelvin: 1400, rgb: [255, 101, 0] },
        { kelvin: 1500, rgb: [255, 109, 0] },
        { kelvin: 1600, rgb: [255, 115, 0] },
        { kelvin: 1700, rgb: [255, 121, 0] },
        { kelvin: 1800, rgb: [255, 126, 0] },
        { kelvin: 1900, rgb: [255, 131, 0] },
        { kelvin: 2000, rgb: [255, 138, 18] },
        { kelvin: 2100, rgb: [255, 142, 33] },
        { kelvin: 2200, rgb: [255, 147, 44] },
        { kelvin: 2300, rgb: [255, 152, 54] },
        { kelvin: 2400, rgb: [255, 157, 63] },
        { kelvin: 2500, rgb: [255, 161, 72] },
        { kelvin: 2600, rgb: [255, 165, 79] },
        { kelvin: 2700, rgb: [255, 169, 87] },
        { kelvin: 2800, rgb: [255, 173, 94] },
        { kelvin: 2900, rgb: [255, 177, 101] },
        { kelvin: 3000, rgb: [255, 180, 107] },
        { kelvin: 3100, rgb: [255, 184, 114] },
        { kelvin: 3200, rgb: [255, 187, 120] },
        { kelvin: 3300, rgb: [255, 190, 126] },
        { kelvin: 3400, rgb: [255, 193, 132] },
        { kelvin: 3500, rgb: [255, 196, 137] },
        { kelvin: 3600, rgb: [255, 199, 143] },
        { kelvin: 3700, rgb: [255, 201, 148] },
        { kelvin: 3800, rgb: [255, 204, 153] },
        { kelvin: 3900, rgb: [255, 206, 159] },
        { kelvin: 4000, rgb: [255, 209, 163] },
        { kelvin: 4100, rgb: [255, 211, 168] },
        { kelvin: 4200, rgb: [255, 213, 173] },
        { kelvin: 4300, rgb: [255, 215, 177] },
        { kelvin: 4400, rgb: [255, 217, 182] },
        { kelvin: 4500, rgb: [255, 219, 186] },
        { kelvin: 4600, rgb: [255, 221, 190] },
        { kelvin: 4700, rgb: [255, 223, 194] },
        { kelvin: 4800, rgb: [255, 225, 198] },
        { kelvin: 4900, rgb: [255, 227, 202] },
        { kelvin: 5000, rgb: [255, 228, 206] },
        { kelvin: 5100, rgb: [255, 230, 210] },
        { kelvin: 5200, rgb: [255, 232, 213] },
        { kelvin: 5300, rgb: [255, 233, 217] },
        { kelvin: 5400, rgb: [255, 235, 220] },
        { kelvin: 5500, rgb: [255, 236, 224] },
        { kelvin: 5600, rgb: [255, 238, 227] },
        { kelvin: 5700, rgb: [255, 239, 230] },
        { kelvin: 5800, rgb: [255, 240, 233] },
        { kelvin: 5900, rgb: [255, 242, 236] },
        { kelvin: 6000, rgb: [255, 243, 239] },
        { kelvin: 6100, rgb: [255, 244, 242] },
        { kelvin: 6200, rgb: [255, 245, 245] },
        { kelvin: 6300, rgb: [255, 246, 247] },
        { kelvin: 6400, rgb: [255, 248, 251] },
        { kelvin: 6500, rgb: [255, 249, 253] },
        // ];
        { kelvin: 6600, rgb: [254, 249, 255] },
        { kelvin: 6700, rgb: [252, 247, 255] },
        { kelvin: 6800, rgb: [249, 246, 255] },
        { kelvin: 6900, rgb: [247, 245, 255] },
        { kelvin: 7000, rgb: [245, 243, 255] },
        { kelvin: 7100, rgb: [243, 242, 255] },
        { kelvin: 7200, rgb: [240, 241, 255] },
        { kelvin: 7300, rgb: [239, 240, 255] },
        { kelvin: 7400, rgb: [237, 239, 255] },
        { kelvin: 7500, rgb: [235, 238, 255] },
        { kelvin: 7600, rgb: [233, 237, 255] },
        { kelvin: 7700, rgb: [231, 236, 255] },
        { kelvin: 7800, rgb: [230, 235, 255] },
        { kelvin: 7900, rgb: [228, 234, 255] },
        { kelvin: 8000, rgb: [227, 233, 255] },
        { kelvin: 8100, rgb: [225, 232, 255] },
        { kelvin: 8200, rgb: [224, 231, 255] },
        { kelvin: 8300, rgb: [222, 230, 255] },
        { kelvin: 8400, rgb: [221, 230, 255] },
        { kelvin: 8500, rgb: [220, 229, 255] },
        { kelvin: 8600, rgb: [218, 229, 255] },
        { kelvin: 8700, rgb: [217, 227, 255] },
        { kelvin: 8800, rgb: [216, 227, 255] },
        { kelvin: 8900, rgb: [215, 226, 255] },
        { kelvin: 9000, rgb: [214, 225, 255] },
        { kelvin: 9100, rgb: [212, 225, 255] },
        { kelvin: 9200, rgb: [211, 224, 255] },
        { kelvin: 9300, rgb: [210, 223, 255] },
        { kelvin: 9400, rgb: [209, 223, 255] },
        { kelvin: 9500, rgb: [208, 222, 255] },
        { kelvin: 9600, rgb: [207, 221, 255] },
        { kelvin: 9700, rgb: [207, 221, 255] },
        { kelvin: 9800, rgb: [206, 220, 255] },
        { kelvin: 9900, rgb: [205, 220, 255] },
        { kelvin: 10000, rgb: [207, 218, 255] },
        { kelvin: 10100, rgb: [207, 218, 255] },
        { kelvin: 10200, rgb: [206, 217, 255] },
        { kelvin: 10300, rgb: [205, 217, 255] },
        { kelvin: 10400, rgb: [204, 216, 255] },
        { kelvin: 10500, rgb: [204, 216, 255] },
        { kelvin: 10600, rgb: [203, 215, 255] },
        { kelvin: 10700, rgb: [202, 215, 255] },
        { kelvin: 10800, rgb: [202, 214, 255] },
        { kelvin: 10900, rgb: [201, 214, 255] },
        { kelvin: 11000, rgb: [200, 213, 255] },
        { kelvin: 11100, rgb: [200, 213, 255] },
        { kelvin: 11200, rgb: [199, 212, 255] },
        { kelvin: 11300, rgb: [198, 212, 255] },
        { kelvin: 11400, rgb: [198, 212, 255] },
        { kelvin: 11500, rgb: [197, 211, 255] },
        { kelvin: 11600, rgb: [197, 211, 255] },
        { kelvin: 11700, rgb: [197, 210, 255] },
        { kelvin: 11800, rgb: [196, 210, 255] },
        { kelvin: 11900, rgb: [195, 210, 255] },
        { kelvin: 12000, rgb: [195, 209, 255] }
    ];

    static readonly FlowModel = [
        { Text: 'TFS_050', Value: 0, KValue: 0.078000, Offset: +0.9000000, PipeSize: 0.5 },
        { Text: 'TFS_075', Value: 1, KValue: 0.156300, Offset: +0.9000000, PipeSize: 0.75 },
        { Text: 'TFS_100', Value: 2, KValue: 0.261120, Offset: +1.2000000, PipeSize: 1.0 },
        { Text: 'TFS_150', Value: 3, KValue: 1.699000, Offset: -0.316000, PipeSize: 1.5 }, //	228PV15XX.XXX
        { Text: 'TFS_200', Value: 4, KValue: 2.842900, Offset: +0.143500, PipeSize: 2.0 }, //	228PV20XX.XXX
        { Text: 'TFS_300', Value: 5, KValue: 8.309000, Offset: +0.227000, PipeSize: 3.0 }, //	228PV30XX.XXX
        { Text: 'TFS_400', Value: 6, KValue: 13.742830, Offset: +0.237070, PipeSize: 4.0 }, //	228PV40XX.XXX
        { Text: 'FS_B100', Value: 7, KValue: 109.000000, Offset: +27.000000, PipeSize: 1.0 }, // IRRITROL 1.0”
        { Text: 'FS_B125', Value: 8, KValue: 209.000000, Offset: +32.000000, PipeSize: 1.25 }, // IRRITROL 1.25”
        { Text: 'FS_B150', Value: 9, KValue: 291.000000, Offset: +24.000000, PipeSize: 1.5 }, // IRRITROL 1.5”
        { Text: 'FS_B200', Value: 10, KValue: 750.000000, Offset: +0.000000, PipeSize: 2.0 }, // IRRITROL 2.0”
        { Text: 'FS_B250', Value: 11, KValue: 1021.000000, Offset: +370.000000, PipeSize: 2.5 }, // IRRITROL 2.5”
        { Text: 'FS_150', Value: 12, KValue: 457.000000, Offset: +0.000000, PipeSize: 1.5 }, // IRRITROL 1.5”
        { Text: 'FS_200', Value: 13, KValue: 776.000000, Offset: +104.000000, PipeSize: 2.0 }, // IRRITROL 2.0”
        { Text: 'FS_300', Value: 14, KValue: 2268.000000, Offset: +483.000000, PipeSize: 3.0 }, // IRRITROL 3.0”
        { Text: 'FS_400', Value: 15, KValue: 3752.000000, Offset: +834.000000, PipeSize: 4.0 }, // IRRITROL 4.0”
        { Text: 'FS_10', Value: 16, KValue: 87.000000, Offset: +6.000000, PipeSize: 1.0 }, // IRRITROL 1.0”
        { Text: 'FS_B15', Value: 17, KValue: 208.000000, Offset: +34.000000, PipeSize: 1.5 }, // IRRITROL 1.5”
        { Text: 'FS_15', Value: 18, KValue: 177.000000, Offset: +205.000000, PipeSize: 1.5 }, // IRRITROL 1.5”
        { Text: 'FS_20', Value: 19, KValue: 325.000000, Offset: +256.000000, PipeSize: 2.0 }, // IRRITROL 2.0”
        { Text: 'RM_S30', Value: 20, KValue: 751.000000, Offset: +431.000000, PipeSize: 3.0 }, // IRRITROL 3.0”
        { Text: 'RM_S40', Value: 21, KValue: 1237.000000, Offset: +303.000000, PipeSize: 4.0 }, // IRRITROL 4.0”
        { Text: 'RM_S60', Value: 22, KValue: 2839.000000, Offset: +903.000000, PipeSize: 6.0 }, // IRRITROL 6.0”
        { Text: 'Custom', Value: 23, KValue: 0, Offset: +0, PipeSize: 0 }, //Custom FlowSensor
       /*  { Text: 'OFF', Value: 24, KValue: 0, Offset: 0, PipeSize: 0 } */];

    static readonly monthsList = [
        { Text: 'January', Label: 'Jan' },
        { Text: 'February', Label: 'Feb' },
        { Text: 'March', Label: 'Mar' },
        { Text: 'April', Label: 'Apr' },
        { Text: 'May', Label: 'May' },
        { Text: 'June', Label: 'Jun' },
        { Text: 'July', Label: 'Jul' },
        { Text: 'August', Label: 'Aug' },
        { Text: 'September', Label: 'Sep' },
        { Text: 'October', Label: 'Oct' },
        { Text: 'November', Label: 'Nov' },
        { Text: 'December', Label: 'Dec' }
    ];
}
